export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Meteorology Educator — Bristol, United Kingdom',
    'My students finally understand the difference between weather systems and climate patterns. I used to waste hours searching for the right way to explain how atmospheric circulation works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Earth Science Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain cloud formation or how to interpret weather data. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Environmental Science Teacher — Munich, Germany',
    'The lesson planning saves me countless hours. The integrated meteorology projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Meteorology Educator | Bristol, United Kingdom',
    "The material on atmospheric thermodynamics and cloud formation completely changed how my students understand weather. They finally grasp how pressure systems develop and storms form. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Earth Science Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Environmental Science Teacher | Berlin, Germany',
    "The 100 real-world case studies transformed how my students see weather hazards. Now they analyze authentic tornado, hurricane, and flooding events and understand why meteorological knowledge matters. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The meteorology lesson-planning library gave me back my class time. I used to spend hours creating lesson sequences. Now I use the framework and my students instantly engage with the content.',
  ],
  [
    'MS',
    'Martin S.',
    'Meteorology Instructor | Copenhagen, Denmark',
    "The 100 experiments and investigations were eye-opening. My students finally understand why all this matters. They're collecting weather data in their communities, making forecasts, and analyzing atmospheric patterns. This completely transformed how they see meteorology.",
  ],
];
